import { render, staticRenderFns } from "./beHavior.vue?vue&type=template&id=58d6f3b0&"
import script from "./beHavior.vue?vue&type=script&lang=js&"
export * from "./beHavior.vue?vue&type=script&lang=js&"
import style0 from "./beHavior.vue?vue&type=style&index=0&id=58d6f3b0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports